import _ from 'lodash';
import { createSelector } from 'reselect';

const resourceSelector = (state, props = {}) => _.get(state.resources, `${props?.resource?.key}`);

export const advancedSearchFiltersSelector = createSelector(resourceSelector, (resource) => resource?.filters ?? {});
